"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = isObject;
exports.hasArg = hasArg;
exports.luhn10 = luhn10;
exports.Str = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Check if the value is a javascript object.
 *
 * @param value
 * @returns {boolean}
 */
function isObject(value) {
  var type = _typeof(value);

  return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a string with the format: rule:arg
 *
 * @param value
 * @returns {boolean}
 */


function hasArg(value) {
  return typeof value === 'string' && value.split(':').length > 1;
}
/**
 * Validate a variety of identification numbers, such as credit card numbers, IMEI numbers, National Provider Identifier numbers
 *
 * https://en.wikipedia.org/wiki/Luhn_algorithm
 * @param identifier
 * @returns {boolean}
 */


function luhn10(identifier) {
  if (!identifier || !identifier.length) return false; // Check that the number is numeric

  var cardExp = /^[0-9]{13,19}$/;

  if (!cardExp.exec(identifier)) {
    return false;
  }

  var sum = 0;
  var alt = false;
  var i = identifier.length - 1;
  var num;

  while (i >= 0) {
    num = parseInt(identifier.charAt(i), 10);

    if (alt) {
      num *= 2;

      if (num > 9) {
        num = num % 10 + 1; // eslint-disable-line no-extra-parens
      }
    }

    alt = !alt;
    sum += num;
    i--;
  }

  return sum % 10 === 0;
}

;

var Str = function Str(str) {
  return {
    // Determines if a string begins with the given string
    starts_with: function starts_with(value) {
      return str.indexOf(value) === 0;
    }
  };
};

exports.Str = Str;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/utils/Helper.js
// module id = yIN/
// module chunks = 0 1